// extracted by mini-css-extract-plugin
export default {"days":"style_days__hnF-c","chooseDay":"style_chooseDay__TaS-C"};